import { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Container } from 'reactstrap';
import '../../styles/chord-direction.css';

import ChordShiftIcon from '../../assets/icons/chord-direction-button.svg';
import ChordShiftIconMember from '../../assets/icons/chord-direction-button-member.svg';
import CommonButton from './CommonButton';
import { Handler, SCORE_STORE_KEY } from '../../common/handler';

const ChordDirectionButton = ({
    showDialog,
    onClick,
    handler,
    isMember,
}: {
    showDialog?: boolean;
    onClick?: () => void;
    handler?: Handler | null;
    isMember: boolean;
}) => {
    const [show, setShowDialog] = useState<boolean>(false);
    const [currentDirection, setDirection] = useState<string>('none');
    const [chordDirection] = useState<Array<string>>([
        '1451',
        '1645',
        '1564',
        '6451',
        '6415',
        '6543',
        '4566',
        '2516',
        '大调四度圈',
        '小调四度圈',
        '大调Leading Bass',
        '小调Leading Bass',
    ]);

    useEffect(() => {
        if (!showDialog) {
            setShowDialog(false);
        }
    }, [showDialog]);

    useEffect(() => {
        if (show) {
            setDirection('none');
        }
    }, [show]);

    const handleClick = (v: string) => {
        setDirection(v);
        // 清除当前乐谱
        handler?.cleanAll();
        // 渲染新的乐谱
        const melodyStaves: any[] = [];
        const chordStaves: any[] = [];
        switch (v) {
            case '1451':
                [
                    ['G/4', 'E/5'],
                    ['A/4', 'F/5'],
                    ['G/4', 'F/5'],
                    ['G/4', 'E/5'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['A/4', 'B/5'],
                    ['D/5', 'A/5'],
                    ['E/5', 'G/5'],
                    ['A/4', 'A/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '1645':
                [
                    ['G/4', 'E/5'],
                    ['A/4', 'E/5'],
                    ['A/4', 'F/5'],
                    ['G/4', 'D/5'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['A/4', 'A/5'],
                    ['F/4', 'A/5'],
                    ['D/4', 'A/5'],
                    ['E/4', 'G/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '1564':
                [
                    ['G/4', 'E/5'],
                    ['G/4', 'D/5'],
                    ['E/4', 'C/5'],
                    ['F/4', 'C/5'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['A/4', 'A/5'],
                    ['E/4', 'G/5'],
                    ['F/4', 'F/5'],
                    ['D/4', 'F/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '6451':
                [
                    ['E/4', 'C/5'],
                    ['F/4', 'C/5'],
                    ['D/4', 'B/4'],
                    ['E/4', 'C/5'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['F/4', 'F/5'],
                    ['D/4', 'F/5'],
                    ['E/4', 'E/5'],
                    ['A/4', 'E/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '6415':
                [
                    ['E/4', 'C/5'],
                    ['F/4', 'C/5'],
                    ['E/4', 'C/5'],
                    ['D/4', 'B/4'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['F/4', 'F/5'],
                    ['D/4', 'F/5'],
                    ['A/4', 'E/5'],
                    ['E/4', 'E/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '6543':
                [
                    ['C/4', 'E/4'],
                    ['D/4', 'G/4'],
                    ['E/4', 'A/4'],
                    ['E/4', 'G/4'],
                ].forEach((item: string[]) => {
                    const accidentals = item[0] === 'E/4' && item[1] === 'G/4' ? [{ index: 1, modifier: '#' }] : [];
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals,
                            },
                        ],
                    });
                });
                [
                    ['F/4', 'F/5'],
                    ['E/4', 'G/5'],
                    ['D/4', 'A/5'],
                    ['C/4', 'B/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '4566':
                [
                    ['C/4', 'A/4'],
                    ['D/4', 'B/4'],
                    ['E/4', 'C/5'],
                    ['E/4', 'C/5'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['D/4', 'E/5'],
                    ['E/4', 'E/5'],
                    ['F/4', 'E/5'],
                    ['F/4', 'E/5'],
                ].forEach((item: string[]) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                break;
            case '2516':
                [
                    ['F/4', 'A/4'],
                    ['F/4', 'A/4'],
                    ['E/4', 'G/4'],
                    ['E/4', 'G/4'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals: [],
                            },
                        ],
                    });
                });
                [
                    ['B/4', 'A/5'],
                    ['E/4', 'A/5'],
                    ['A/4', 'A/5'],
                    ['F/4', 'A/5'],
                ].forEach((item: string[]) => {
                    const accidentals = item[0] === 'F/4' && item[1] === 'A/5' ? [{ index: 1, modifier: '#' }] : [];
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '1',
                                accidentals,
                            },
                        ],
                    });
                });
                break;
            case '大调四度圈':
                [
                    ['A/4', 'E/4'],
                    ['G/4', 'D/4'],
                    ['G/4', 'E/4'],
                    ['G/4', 'E/4'],
                    ['A/4', 'F/4'],
                    ['A/4', 'F/4'],
                    ['G/4', 'E/4'],
                    ['G/4', 'E/4'],
                ].forEach((item: string[]) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals: [],
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                [
                    ['A/5', 'D/4'],
                    ['G/5', 'D/4'],
                    ['G/5', 'C/4'],
                    ['A/5', 'F/4'],
                    ['A/5', 'B/3'],
                    ['A/5', 'E/4'],
                    ['A/5', 'A/3'],
                    ['G/5', 'A/3'],
                ].forEach((item: string[]) => {
                    const accidentals = item[1] === 'A/3' && item[0] === 'G/5' ? [{ index: 0, modifier: 'b' }] : [];
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals,
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                break;
            case '小调四度圈':
                [
                    ['A/4', 'F/4'],
                    ['G/4', 'D/4'],
                    ['G/4', 'E/4'],
                    ['A/4', 'F/4'],
                    ['B/4', 'F/4'],
                    ['G/4', 'E/4'],
                    ['A/4', 'E/4'],
                    ['G/4', 'E/4'],
                ].forEach((item: string[], index: number) => {
                    let accidentals: { index: number; modifier: string }[] = [];
                    if (item[1] === 'F/4' && item[0] === 'B/4') {
                        accidentals = [{ index: 1, modifier: '#' }];
                    }

                    if (index === 5) {
                        accidentals = [{ index: 0, modifier: '#' }];
                    }

                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals: accidentals,
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                [
                    ['A/5', 'B/4'],
                    ['G/5', 'E/5'],
                    ['A/5', 'A/4'],
                    ['A/5', 'D/5'],
                    ['B/5', 'G/4'],
                    ['B/5', 'C/5'],
                    ['F/5', 'F/4'],
                    ['F/5', 'F/4'],
                ].forEach((item: string[], index: number) => {
                    const accidentals = index === 7 ? [{ index: 0, modifier: '#' }] : [];
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals,
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                break;

            case '大调Leading Bass':
                [
                    ['G/4', 'D/4'],
                    ['G/4', 'D/4'],
                    ['G/4', 'C/4'],
                    ['G/4', 'C/4'],
                    ['G/4', 'C/4'],
                    ['G/4', 'C/4'],
                    ['F/4', 'C/4'],
                    ['G/4', 'B/3'],
                ].forEach((item: string[], index: number) => {
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals: [],
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                melodyStaves.push({
                    notes: [
                        {
                            keys: ['G/4', 'C/4'],
                            duration: '1',
                            accidentals: [],
                        },
                    ],
                });
                [
                    ['C/5', 'A/4'],
                    ['E/5', 'G/4'],
                    ['E/5', 'F/4'],
                    ['C/5', 'E/4'],
                    ['D/5', 'D/4'],
                    ['E/5', 'C/4'],
                    ['F/5', 'B/3'],
                    ['D/5', 'E/4'],
                ].forEach((item: string[], index: number) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals: [],
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                chordStaves.push({
                    notes: [
                        {
                            keys: ['A/4', 'C/5'],
                            duration: '1',
                            accidentals: [],
                        },
                    ],
                });
                break;
            case '小调Leading Bass':
                [
                    ['C/5', 'G/4'],
                    ['C/5', 'G/4'],
                    ['C/5', 'A/4'],
                    ['C/5', 'G/4'],
                    ['A/4', 'F/4'],
                    ['C/5', 'G/4'],
                    ['B/4', 'F/4'],
                    ['B/4', 'G/4'],
                ].forEach((item: string[], index: number) => {
                    let accidentals: { index: number; modifier: string }[] = [];
                    if (index === 6 || index === 7) {
                        accidentals = [{ index: 1, modifier: '#' }];
                    }
                    melodyStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals,
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                melodyStaves.push({
                    notes: [
                        {
                            keys: ['E/4', 'A/4'],
                            duration: '1',
                            accidentals: [],
                        },
                    ],
                });
                [
                    ['C/6', 'F/5'],
                    ['C/6', 'E/5'],
                    ['A/5', 'D/5'],
                    ['A/5', 'C/5'],
                    ['B/5', 'B/4'],
                    ['C/6', 'A/4'],
                    ['B/5', 'G/4'],
                    ['B/5', 'C/5'],
                ].forEach((item: string[], index: number) => {
                    chordStaves.push({
                        notes: [
                            {
                                keys: item,
                                duration: '2',
                                accidentals: [],
                                direction: ['up', 'down'],
                            },
                        ],
                    });
                });
                chordStaves.push({
                    notes: [
                        {
                            keys: ['F/4', 'A/5'],
                            duration: '1',
                            accidentals: [],
                        },
                    ],
                });
                break;
        }
        localStorage.setItem(SCORE_STORE_KEY, JSON.stringify({ melodyStaves, chordStaves }));
        handler?.init();
    };

    return (
        <div className="chord-direction">
            <button
                className="right-button"
                onClick={() => {
                    onClick && onClick();
                    setShowDialog(!show);
                }}
            >
                <img src={isMember ? ChordShiftIconMember : ChordShiftIcon} alt="save-icon" />
            </button>
            {showDialog && show && (
                <div className="dialog">
                    <Container>
                        <Form className="chord-direction-form">
                            <FormGroup noMargin>
                                <Label size="sm">添加和弦</Label>
                                {chordDirection.map((v: string) => (
                                    <CommonButton
                                        title={v}
                                        type={currentDirection === v ? 'active' : 'normal'}
                                        key={v}
                                        onClick={() => handleClick(v)}
                                    />
                                ))}
                            </FormGroup>
                        </Form>
                    </Container>
                </div>
            )}
        </div>
    );
};

export default ChordDirectionButton;
